import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.CLOUD_SERVICES)

const MANAGEMNT_TASK = [
  { title: 'Cloud Migration',desc: 'Move applications, databases, workloads, and infrastructure to the cloud with a structured approach designed to minimize disruption.' },
  { title: 'Cloud Architecture',      desc: 'Design secure, scalable, and resilient cloud environments aligned with application and business requirements.' },
  { title: 'Cloud Infrastructure Management',           desc: 'Manage cloud resources, environments, configurations, availability, monitoring, backups, and operational requirements.' },
  { title: 'Application Modernization',  desc: 'Adapt existing applications and architectures to take better advantage of cloud capabilities and modern deployment models.' },
  { title: 'Cloud Security', desc: 'Implement appropriate access controls, configurations, monitoring, backup strategies, and security practices across cloud environments.' },
  { title: 'Cloud Optimization',   desc: 'Review cloud resources, utilization, performance, and architecture to improve efficiency and manage unnecessary infrastructure costs.' },  
]
const CLOUDE_SERVICE_LIFECYCLE = ['Assess', 'Plan', 'Migrate', 'Modernize', 'Manage', 'Optimize']
export default function CloudServices() {
  

  return (
    <>
    {/* <MetaInfo
        title="Cloud Services & Management | CruxBytes"
        description="Cloud migration, infrastructure management, optimization and support services to help businesses build secure, scalable and reliable cloud environments."
        keywords="cloud services, cloud migration, cloud management, cloud optimization, cloud security, application modernization, CruxBytes"
      /> */}
       <MetaInfo
     title={label} 
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Maintenance & Support -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Cloud Services & Management */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Seamlessly migrate applications and infrastructure to the cloud. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
          {/* section 1 */}
                 <section className="bg-linear-gradient-light section-py" >
               <div className="container">
                  <p className="text-center" data-aos="fade-up">
                      Cloud technology can help businesses improve scalability, availability, flexibility, and operational efficiency—but getting the most from the cloud requires the right architecture and ongoing management.
                     </p>
                     <p className="text-center" data-aos="fade-up">
                      CruxBytes helps organizations adopt, modernize, manage, and optimize cloud environments based on their applications, workloads, security requirements, and business objectives. Some of our cloud services that fir your business
                     </p>
                 
                     <div className="wcs-grid wcs-grid--cols-3">
              {MANAGEMNT_TASK.map((item, i) => (
                <div
                  key={item.title}
                  className="wcs-card bg-white"
                  data-aos="fade-up"
                  data-aos-delay={i * 80}
                >
                  {i > 0 && <div className="sc-code-divider" aria-hidden="true" />}                 
                  <h3 className="wcs-title">{item.title}</h3>
                  <p className="wcs-desc">{item.desc}</p>
                </div>
              ))}
            </div>
                 
               </div>
             </section>


              <section className="section-py ">
                <div className="container ">
        <div className="on-demand-split">
                  {/* ── LEFT ── */}
         <div className="cp-timeline" data-aos="fade-right" aria-label="Our hiring process">
        
          <div className="cp-timeline-header">
            <h2 >Cloud Across the Application Lifecycle</h2>
            <p >
            Whether you're moving an existing application to the cloud, building a new cloud-native platform, or looking for ongoing cloud management, CruxBytes helps create a cloud environment that can evolve with your business.
            </p> 
            <p>
              Our focus is not simply getting applications into the cloud. It is creating a <span className='text-bold'>secure, reliable, scalable, and efficiently managed cloud foundation</span> that continues to support your business as it grows.
            </p>           
          </div>     
        </div>
                {/* ── RIGHT:  ── */}
        <div   data-aos="fade-left">  
          <div className="contact-form-wrap" style={{backgroundColor:'var(--brand-100)'}}>
            <h6>Cloud That Works Beyond Migration</h6>
            <ol className="step-flow  mt-4" role="list" aria-label="Testing lifecycle">
              {CLOUDE_SERVICE_LIFECYCLE.map((step) => (
                <li key={step} className="step-flow-item">
                  <span className="step-flow-label" style={{fontSize:'var(--fs-xs)'}}>{step}</span>
                </li>
              ))}
            </ol>
            
            
          </div>
        </div>
        </div>   
      </div>                
         </section>
         <TransformBanner />
         </main>
         </>
  )
}